export default __webpack_public_path__ + "static/SR China - Kosher - Certificate-d1422d3b8a9426d059731dc271b0a154.pdf";